<template>
  <div class="card mb-25 border-0 rounded-0 bg-white website-visitors radius-7">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <div
        class="mb-lg-15 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">{{ getDashboardSemesterCards.semester }}° Semestre</h6>
      </div>
      <div id="websiteVisitorsChart" class="chart">
        <apexchart
          type="bar"
          height="385"
          :options="websiteVisitorsChart"
          :series="[{name: 'Quantidade',data: [{x: 'Sucesso', y: getDashboardSemesterCards.total_success, fillColor: '#1D6FF2'}, {x: 'Erro', y: getDashboardSemesterCards.total_error, fillColor: '#C33F52'}]}]"
        ></apexchart>
      </div>
      <div class="expected-earnings-box">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing d-flex justify-content-around">
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li class="text-muted position-relative fw-medium">
              Upload com sucesso: <span class="text-black fw-bold">{{ getDashboardSemesterCards.total_success }}</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              Tempo total: <span class="text-black fw-bold">{{ convertTime(getDashboardSemesterCards.total_time) }}</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              AM: <span class="text-black fw-bold">{{ getDashboardSemesterCards.am }}</span>
            </li>
          </ul>
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li class="text-muted position-relative fw-medium">
              Upload com erro: <span class="text-black fw-bold">{{ getDashboardSemesterCards.total_error }}</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              Tamanho total: <span class="text-black fw-bold">{{ (getDashboardSemesterCards.total_size / (1024 * 1024)).toFixed(2) + " MB" }}</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              PM: <span class="text-black fw-bold">{{ getDashboardSemesterCards.pm }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "WebsiteVisitors",
  data: function () {
    return {
      website: [
        {
          name: "Quantidade",
          data: [
            {
              x: "Sucesso",
              y: 11,
              fillColor: "#1D6FF2",
            },
            {
              x: "Erro",
              y: 3,
              fillColor: "#C33F52",
            },
          ],
        }
      ],
      websiteVisitorsChart: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            horizontal: false,
            columnWidth: "28%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#1D6FF2", "#C33F52"],
        stroke: {
          show: false,
        },
        xaxis: {
          categories: ["Sucesso", "Erro"],
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#1D6FF2", "#C33F52"],
              fontSize: "14px",
              fontWeight: 500,
            },
          },
        },
        yaxis: {
          show: true,
          tickAmount: 8,
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#607089","#C33F52"],
              fontSize: "14px",
              fontWeight: 500,
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
        grid: {
          show: true,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
      },
    };
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      "getDashboardSemesterCards",
    ])
  },
});
</script>
